import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { format } from 'date-fns';
import { ToastService } from 'ng-uikit-pro-standard';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { debounceTime, filter } from 'rxjs/operators';
import { BodegaService } from 'src/app/services/bodega.service';
import { DocumentoRecibidoService } from 'src/app/services/documento-recibido.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { ConsoleService } from "src/app/shared/services/console.service";
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { ModalSeleccionarProveedorComponent } from 'src/app/views/shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
import { ModalAddEditEquivalenciaComponent } from '../modal-add-edit-equivalencia/modal-add-edit-equivalencia/modal-add-edit-equivalencia.component';

@Component({
  selector: 'app-modal-add-doc-recibido',
  templateUrl: './modal-add-doc-recibido.component.html',
  styleUrls: ['../../empresas-recibidos.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class ModalAgregarDocumentoRecibidoComponent implements OnInit {

  // Modales
  @ViewChild('agregarDocumentoRecibido', { static: true }) agregarDocumentoRecibidoModal: ModalDirective;
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent
  @ViewChild(ModalAddEditEquivalenciaComponent, { static: true }) addEditModalEquivalencia: ModalAddEditEquivalenciaComponent
  @ViewChild('datePickerFechaRecepcion', { static: false }) datePickerFechaRecepcion: any;

  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>()
  @Output() onExecuteBuscar: EventEmitter<any> = new EventEmitter<any>()

  formHeader: FormGroup;

  // Data & tmp
  public rutEmpresa: number
  public sucursalCodigo: number
  public rut_usuario: number;
  proveedorSeleccionado: any = null
  headerData: any = {}
  selectTipoDTECodigo: any;
  //Cabecera
  listaMovimientos: Array<any> = null;
  optionsTipoDocumento: Array<any> = [];
  optionsBodega: Array<any> = [];
  listaDoc: Array<any> = null;
  optionsMonth: Array<any> = [];
  optionsYear: Array<any> = [];
  // Utils
  private log: any
  montoNetoT: number = 0;
  montoTotal: number = 0;
  montoExento: number = 0;
  montoIva: number = 0;
  Import: any;
  disabledImport: boolean = true;
  band: number = 0;
  processing: boolean = false;
  fechaRecepcionValue: any = null;

  constructor(
    private accesolocalstorage: SecurityService,
    private rutService: RutService,
    private clog: ConsoleService,
    private bodegaService: BodegaService,
    private formValidatorsService: FormValidatorsService,
    private fb: FormBuilder,
    private tipoDocumentoService: TipoDTEService,
    private datesService: DatesService,
    private documentoRecibidoService: DocumentoRecibidoService,
    private toastService: ToastService,
    private messageRendererService: MessageRendererService,


  ) {
    this.log = this.clog.log('AGREGAR-DOCUMENTO-RECIBIDO-VIEW')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rut_usuario = this.accesolocalstorage.getRutUsuario();

    this.loadMonths();
    this.loadYears();
    this.createForm();
    this.setDefaults();
    this.loadBodega();
    this.loadTipoDte();
    this.formChangesSubscriptions();

  }

  loadMonths() {
    this.optionsMonth = this.datesService.GetCurrentMonths('desc')
  }

  loadYears() {
    this.optionsYear = this.datesService.GetLastYears()
  }

  setDefaults() {
    if (this.optionsMonth.length > 0)
      this.formHeader.get('mes').setValue(this.optionsMonth[0].value)
    if (this.optionsYear.length > 0)
      this.formHeader.get('anho').setValue(this.optionsYear[0].value)
  }


  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()

    this.formHeader = this.fb.group({
      mes: [null],
      anho: [null],
      tipoBodega: [''],
      tipoDocumento: [null, []],
      rutProveedor: [null, [Validators.required]],
      direccion: [null],
      IdDoc: [0],
      IdXML: [0],
      DescGlb: [0],
      folio: [0],
      fechaEmision: [initDate],
      RecargoGbl: [0],
      fechaVencimiento: [currentDate],
      fechaRecepcion: [currentDate],
      GMovStock: [true],
      GMovCtaCte: [true]
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutProveedor").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutProveedor: string) => {
        this.modalSeleccionarProveedor.searchByRut(rutProveedor)
      })

    this.formHeader.get('GMovStock').valueChanges
    .pipe(filter(() => Array.isArray(this.listaDoc)))
    .subscribe((checked: boolean) => this.toggleMoveInventoryAll(checked));
  }

  // Método para sincronizar el valor del ngModel con el formulario
  onFechaRecepcionChange(value: any) {
    this.formHeader.get('fechaRecepcion').setValue(value);
  }

  loadBodega() {
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo
    }

    this.bodegaService.ObtenerBodegas(inputParams, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega =>
      ({
        value: bodega.codigo,
        label: bodega.nombre,
        ...bodega
      }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoBodega'), this.optionsBodega)
    })
  }

  loadTipoDte() {
    // Tipos documentos
    this.tipoDocumentoService.GetTiposDocumento(({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsTipoDocumento = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoDocumento'), this.optionsTipoDocumento)
    })
  }


  loadAndShow(cliente, doc, params) {
    this.processing = false;
    console.log("Que trae?", cliente, doc, params);

    this.selectTipoDTECodigo = params;
    //disabled or enable button Importar al ERP
    //azul
    if (doc.mes_recepcion != null && doc.mes_recepcion > 0) {
      this.disabledImport = true;
      this.band = 0;

    }
    // rojo
    if (doc.no_procesado === true && doc.mes_recepcion === null) {
      this.disabledImport = false;
      this.band = 0;
    }

    //negro
    if (doc.mes_recepcion === null && doc.no_procesado === false) {
      this.disabledImport = true;
      this.band = 1;

    }

    const dateFechaDoc = format(new Date(cliente.cabecera.fecha_emision), 'yyyy-MM-dd');
    const dateFechaVenc = format(new Date(cliente.cabecera.fecha_vencimiento), 'yyyy-MM-dd');
    const dateFechaRecepcion = format(new Date(cliente.cabecera.fecha_recepcion), 'yyyy-MM-dd');;
    console.log('Fecha recepción original:', cliente.cabecera.fecha_recepcion);
    console.log('Fecha recepción formateada:', dateFechaRecepcion);
    this.show();
    this.formHeader.get('rutProveedor').setValue(this.rutService.AgregarDV(cliente.cabecera.rut_emisor));
    this.formHeader.get('direccion').setValue(cliente.cabecera.direccion_completa_facturacion);

    if (cliente.descuentosGlobales.length > 0) {
      cliente.descuentosGlobales.map(desc => {
        if (desc.es_descuento === true && cliente.descuentosGlobales.length === 1) {
          this.formHeader.get('DescGlb').setValue(desc.monto_descuento.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."));
        }

        if (desc.es_descuento === false && cliente.descuentosGlobales.length === 1) {
          this.formHeader.get('RecargoGbl').setValue(desc.monto_descuento.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."));
        }

        if (cliente.descuentosGlobales.length === 2) {
          if (desc.es_descuento === true) {
            this.formHeader.get('DescGlb').setValue(desc.monto_descuento.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."));
          } else {
            this.formHeader.get('RecargoGbl').setValue(desc.monto_descuento.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."));
          }
        }
      })
    } else {
      this.formHeader.get('DescGlb').setValue(0);
      this.formHeader.get('RecargoGbl').setValue(0);
    }


    this.formHeader.get('fechaEmision').setValue(dateFechaDoc);

    if (cliente.cabecera.id_lsoft != null) {
      this.formHeader.get('IdDoc').setValue(cliente.cabecera.id_lsoft);
    }

    if (cliente.cabecera.id_xml != null) {
      this.formHeader.get('IdXML').setValue(cliente.cabecera.id_xml);
    }

    if (cliente.cabecera.folio != null) {
      this.formHeader.get('folio').setValue(cliente.cabecera.folio);
    }
    if (cliente.cabecera.es_mov_inv_compra !== null) {
      this.formHeader.get('GMovStock').setValue(cliente.cabecera.es_mov_inv_compra);
    }


    this.formHeader.get('fechaVencimiento').setValue(dateFechaVenc);

    this.formHeader.get('fechaRecepcion').setValue(dateFechaRecepcion);
    this.fechaRecepcionValue = dateFechaRecepcion;



    this.formHeader.get('tipoDocumento').setValue(cliente.cabecera.tipo_dte_codigo); // code:33 - factura
    this.Import = cliente;
    this.listaDoc = cliente.detalleDocumento;
    console.log(this.listaDoc);
    this.listaDoc.forEach((mov, index) => {
      mov.mov_inv_detalle = mov.producto_valido && cliente.cabecera.es_mov_inv_compra && mov.es_mov_inv_compra_detalle;
      mov.additionalInfo = {}
      mov.additionalInfo.index = index
      mov.additionalInfo.checked = true
    })
    this.montoNetoT = cliente.cabecera.monto_total_neto
    this.montoTotal = cliente.cabecera.monto_total
    this.montoExento = cliente.cabecera.monto_exento
    // this.Iva =
    this.montoIva = cliente.cabecera.monto_iva
    // this.OtrosImp =
  }

  updateListaDoc(cliente) {
    this.listaDoc = cliente.detalleDocumento;
    this.listaDoc.forEach((mov, index) => {
      mov.additionalInfo = {}
      mov.additionalInfo.index = index
      mov.additionalInfo.checked = true
    })
    this.montoNetoT = cliente.cabecera.monto_total_neto
    this.montoTotal = cliente.cabecera.monto_total
    this.montoExento = cliente.cabecera.monto_exento
    this.montoIva = cliente.cabecera.monto_iva

  }

  show() {
    //this.isEditing = false
    this.agregarDocumentoRecibidoModal.show()

    // Asegurar que el valor de fecha se asigne después de que el modal esté completamente visible
    setTimeout(() => {
      const fechaRecepcionValue = this.formHeader.get('fechaRecepcion').value;
      if (fechaRecepcionValue && this.datePickerFechaRecepcion) {
        console.log('Modal mostrado, re-asignando fecha:', fechaRecepcionValue);
        const fechaDate = new Date(fechaRecepcionValue);

        // Intentar diferentes métodos del componente
        if (this.datePickerFechaRecepcion.setValue) {
          this.datePickerFechaRecepcion.setValue(fechaDate);
          console.log('Fecha re-asignada usando setValue');
        } else if (this.datePickerFechaRecepcion.value !== undefined) {
          this.datePickerFechaRecepcion.value = fechaDate;
          console.log('Fecha re-asignada usando value');
        } else {
          // Forzar la actualización del formulario
          this.formHeader.get('fechaRecepcion').setValue(fechaDate);
          console.log('Fecha re-asignada al formulario');
        }
      }
    }, 500);
  }

  selectData(documento) {
    this.listaMovimientos = documento;
    this.listaMovimientos.forEach((mov) => {
      mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
    })
  }

  //BUSCAR NOMBRE RUT EMISOR

  onProveedorSeleccionado({ data, origen }) {
    this.proveedorSeleccionado = data
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut)
    this.formHeader.get('rutProveedor').setValue(this.proveedorSeleccionado.rutFormato)
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null
    this.clearProveeData()
  }
  clearProveeData() {
    this.clearContent()
    this.onProveedorChange.emit(null)
  }
  clearContent() {
    this.headerData = {}
    this.formValidatorsService.reset(this.formHeader)
  }

  //abrir modal Agregar equivalencia
  showAddEquivalencia($event) {
    this.addEditModalEquivalencia.loadAndshow($event)
  }

  changeShowHideButton({ index }, { checked }) {
    // this.listaDoc.forEach(detalle => {
    //   if (detalle.additionalInfo.index === index && detalle.producto_valido) {
    //     detalle.mov_inv_detalle = checked;
    //   }
    // });
    console.log({...this.listaDoc});
    const i = this.listaDoc.findIndex(det => det.additionalInfo.index === index);
    this.listaDoc[i].mov_inv_detalle = checked;

    this.updateGlobalMoveInventoryFlag();
  }


  ImportToERP() {
    console.log("***** IMPORT TO ERP **** ", this.listaDoc);
    const data = this.listaDoc.map(x => {
      if (x.sku === '') {
        x.additionalInfo.checked = false;
      }

      const existeEquivalencia = x.equivalencia_producto_id > 0;

      const params = {
        producto_valido: x.producto_valido,
        nro_linea: x.nro_linea,
        equivalencia_producto_id: x.equivalencia_producto_id,
        codigo_producto_proveedor: x.sku,
        descripcion_producto_proveedor: x.descripcion_producto,
        cantidad: x.cantidad,
        precio_producto_proveedor: x.precio_unitario,
        monto_total: x.monto_total,
        monto_descuento: x.aplicacion_descuento,
        monto_recargo: x.aplicacion_recargo,
        producto_codigo: existeEquivalencia ? x.producto_codigo : 0,
        formato_codigo: existeEquivalencia ? x.formato_erp : '',
        formato_proveedor: x.formato_codigo,
        mov_inv_detalle: x.mov_inv_detalle
      }

      return params;
    })


    const inputParams = {
      entidad: {
        cabecera: {
          rut_emisor: this.Import.cabecera.rut_emisor,
          folio: this.Import.cabecera.folio,
          tipo_dte_codigo: this.Import.cabecera.tipo_dte_codigo,
          rut_empresa: this.rutEmpresa,
          sucursal_codigo: this.sucursalCodigo,
          bodega_codigo: this.formHeader.get('tipoBodega').value,
          id_doc: this.Import.cabecera.id_lsoft,
          id_xml: this.Import.cabecera.id_xml,
          mov_inv_ejecutado: this.formHeader.get('GMovStock').value,
          mov_cta_cte: this.formHeader.get('GMovCtaCte').value,
          mes: this.formHeader.get('mes').value,
          anno: this.formHeader.get('anho').value,
          fecha_vencimiento: this.Import.cabecera.fecha_vencimiento,
          fecha_emision: this.Import.cabecera.fecha_emision,
          monto_total: this.Import.cabecera.monto_total,
          monto_neto: this.Import.cabecera.monto_afecto,
          monto_exento: this.Import.cabecera.monto_exento,
          monto_recargo: this.Import.cabecera.monto_recargo,
          monto_iva: this.Import.cabecera.monto_iva,
          monto_subtotal: 0,
          monto_imp_adic: 0
        },
        detalleDocumento: data
      }
    }

    // console.log('*****¨########*###*#####*******', inputParams)
    this.log('inputParams', JSON.stringify(inputParams))
    this.processing = true;
    this.band = 0;
    this.documentoRecibidoService.guardarDocumentoCompra(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.processing = false;
        this.band = 1;
        return
      }
      this.processing = false;

      this.cleanDetalledocumento(this.listaDoc);
      this.cerrarDocumentoRecibido();
      this.toastService.success('Operación exitosa');
      this.BuscarItems();
    })
  }

  BuscarItems() {
    this.onExecuteBuscar.emit(this.selectTipoDTECodigo);
  }

  cerrarDocumentoRecibido() {
    this.band = 1;
    this.processing = false;
    this.agregarDocumentoRecibidoModal.hide();

  }

  private toggleMoveInventoryAll(checked: boolean) {
    if (!Array.isArray(this.listaDoc)) {
      return;
    }

    this.listaDoc.forEach(detalle => {
      const aplicar = checked && detalle.producto_valido;
      // detalle.additionalInfo.checked = aplicar;
      detalle.mov_inv_detalle = aplicar;
    });
  }

  private updateGlobalMoveInventoryFlag() {
    const validos = this.listaDoc.filter(det => det.producto_valido);
    const todosMarcados = validos.length > 0 && validos.some(det => det.mov_inv_detalle === true);

    this.formHeader.get('GMovStock').setValue(todosMarcados, { emitEvent: false });
  }

  // quitar variables de additionalInfo
  private cleanDetalledocumento(detalleDocumento, cleanCheck: Boolean = true) {
    // let _detalledocumento = [...detalleDocumento]
    let _detalledocumento = [];
    detalleDocumento.forEach(val => _detalledocumento.push(Object.assign({}, val)));
    _detalledocumento.map(p => {
      if (cleanCheck)
        delete p.__typename
      delete p.additionalInfo
    })
    return _detalledocumento
  }
}
